/**
* Search form component
*
* Shows search bar on click and prevents empty search
*/
var component_search_form = function(args) {

  // setup args
  var searchForm = args.search_form; // match this to $menu-visible SASS variable

  var button = searchForm.querySelector('.search-form__submit');

  button.addEventListener('click', function (e) {
    this.parentElement.classList.add('active');
    this.classList.add('active');
    var input = this.previousElementSibling;
    input.classList.add('active');
    input.focus();
  });

  // button.addEventListener('focus', function (e) {
  //   this.parentElement.classList.add('active');
  //   this.classList.add('active');
  //   var input = this.previousElementSibling;
  //   input.classList.add('active');
  //   input.focus();
  // });

  searchForm.addEventListener('submit', function (e) {
    var input = this.querySelector('.search-form__input');
    var value = input.value.trim();
    if (value) {
      input.dataset.state = 'valid'
    } else {
      input.dataset.state = 'invalid'
      e.preventDefault();
    }
  });

  // /**
  // * Activate search form when in focus
  // */
  // var mobileSearchInput = document.querySelector('.site-header__mobile-extramenu .search-form__input');
  // mobileSearchInput.addEventListener('focus', function(e) {
  //   var button = this.parentElement.querySelector('.search-form__submit');
  //   console.log(this.parentElement);

  //   if (!(this.classList.contains('active'))) {
  //     // add .active to input field
  //     this.classList.add('active');
  //   }

  //   if (!(this.parentElement.classList.contains('active'))) {
  //     // add .active to form element
  //     this.parentElement.classList.add('active');
  //   }

  //   if (!(button.classList.contains('active'))) {
  //     // add .active to button
  //     this.parentElement.classList.add('active');
  //   }

  // });

  // /**
  // * De-activate mobile search form when pressing the back button
  // */
  // var mobileSearchBackButton = document.querySelector('.site-header__mobile-extramenu .search-form__back-button');
  // mobileSearchBackButton.addEventListener('click', function(e) {
  //   var button = this.parentElement.querySelector('.search-form__submit');
  //   var input = this.parentElement.querySelector('.search-form__input');
  //   var form = this.parentElement;

  //   if (input.classList.contains('active')) {
  //     // remove .active from input field
  //     input.classList.remove('active');
  //   }

  //   if (form.classList.contains('active')) {
  //     // remove .active from form element
  //     form.classList.remove('active');
  //   }

  //   if (button.classList.contains('active')) {
  //     // remove .active from button
  //     button.classList.remove('active');
  //   }
  // });


  // make the call chainable
  return this;

};
